package Structs

import DataBase.UINKDBInterface
import Utils.*
import kotlinx.serialization.Serializable
import myName

@myName("Product")
@Serializable
data class Product(
    var name: String,
    val id: Int,
    val barcode: String,
    val default_price: Float,
    var position: Int,
    var active: Int,
    val date: String,
    val connected_product: Int = -1,
    val no_tax_product: Int = 0,
    val taklit_id: Int = -1,
    val taklit_type: Int = -1,
    val external_id: String = "-1",
    val unit: Int = 0,
    val unit_amount: Float = 0f,
    val category: String = "",
    val cost_price: Float = 0f,
    val cost_include_returns: Int = 1,
    val split_category: Int = 0,
    val base_price: Float = 0f,
    val category2: String = "",
    val p_range:Float=0f,
    val notes2: String? = null,
    val notes3: String? = null,
    val notes4: String? = null,
    val notes5: String? = null,
    val notes6: String? = null,
    /** Supplier products only (sup_products): their own second/third unit. Client products keep these on [OrderProduct]. */
    val extra_unit: Int = 0,
    val conversion_rate: Float = 0f,
    val third_unit: Int = 0,
    val unit_preferece: Int = 0,

) : Named {
    var isClient: Boolean = true
    var productDated: ProductSequence = ProductSequence()
    var tempPosition: Int = 0

    init {
        name = fixJsonInternal(name)
    }

    @myName("getUnitName")
    fun getUnitName(): String {

        return WrappedName.NONE.convert(unit).MethodName()
    }

    override fun getConnectedName(): String {
        return getName()
    }

    fun getUnitWrapped(): WrappedName {
        return WrappedName.NONE.convert(unit)
    }

    override fun getConnectedSubName(): String? {
        val barcode = getBarcode()
        if (barcode == "0000000000000")
            return null
        return barcode
    }

    override fun getConnectedId(): Int {
        return id
    }

    @myName("getCostDated")
    fun getCostDated(date:String=DatesManipulator.dateNowNoHour()):Float?{
        val pp = UINKDBInterface.activeDB.getProductCost(id)?.get(date)
        pp?.let {cost->
            return (cost.first ) * (1- (cost.second)/100)
        }
        return null
    }
    override fun getActiveState(): Int {
        return active
    }

    fun getTaklitType(): String? {
        if (taklit_type == -1) {
            return null
        }
        return if (taklit_type == 0)
            "סוג א"
        else "מובחר"
    }

    override fun toString(): String {
        return name.toString()
    }

    fun clone(): Product {
        val c =  this.copy()
        c.isClient = this.isClient
        return c
    }

    @myName("getOrderProduct")
    fun getOrderProduct(): OrderProduct? {
        return if(isClient) UINKDBInterface.activeDB.getOrderProduct(id)?.first()  else  getConnectedProduct().firstOrNull()?.getOrderProduct()
    }

    /**
     * The client product whose units a supplier product is counted in: the linked one,
     * when it has any unit set. Null → the supplier product's own units apply.
     */
    private fun linkedUnitSource(): Product? {
        if (isClient) return null
        val linked = getConnectedProduct().firstOrNull() ?: return null
        return if (linked.unit > 0 || linked.getOrderProduct() != null) linked else null
    }

    /** First (charging) unit id: own for client products, linked-or-own for supplier products. */
    @myName("effectiveUnit")
    fun effectiveUnit(): Int {
        if (isClient) return unit
        return linkedUnitSource()?.unit ?: unit
    }

    @myName("effectiveExtraUnit")
    fun effectiveExtraUnit(): Int {
        if (isClient) return getOrderProduct()?.extra_unit ?: 0
        val linked = linkedUnitSource() ?: return extra_unit
        return linked.getOrderProduct()?.extra_unit ?: 0
    }

    @myName("effectiveConversionRate")
    fun effectiveConversionRate(): Float {
        val rate = if (isClient) getOrderProduct()?.conversion_rate ?: 0f
        else linkedUnitSource()?.let { it.getOrderProduct()?.conversion_rate ?: 0f } ?: conversion_rate
        return if (rate > 0f) rate else 0f
    }

    @myName("effectiveThirdUnit")
    fun effectiveThirdUnit(): Int {
        if (isClient) return getOrderProduct()?.third_unit ?: 0
        val linked = linkedUnitSource() ?: return third_unit
        return linked.getOrderProduct()?.third_unit ?: 0
    }

    @myName("effectiveUnitPreference")
    fun effectiveUnitPreference(): Int {
        if (isClient) return getOrderProduct()?.unit_preferece ?: 0
        val linked = linkedUnitSource() ?: return unit_preferece
        return linked.getOrderProduct()?.unit_preferece ?: 0
    }

    /** True when a supplier product takes its units from the linked client product. */
    @myName("unitsFromLinked")
    fun unitsFromLinked(): Boolean = linkedUnitSource() != null

    @myName("getEffectiveUnitName")
    fun getEffectiveUnitName(): String {
        return WrappedName.NONE.convert(effectiveUnit()).MethodName()
    }

    @myName("getEffectiveExtraUnitName")
    fun getEffectiveExtraUnitName(): String? {
        val u = effectiveExtraUnit()
        return if (u > 0) WrappedName.NONE.convert(u).MethodName() else null
    }

    @myName("getEffectiveThirdUnitName")
    fun getEffectiveThirdUnitName(): String? {
        val u = effectiveThirdUnit()
        return if (u > 0) WrappedName.NONE.convert(u).MethodName() else null
    }
    @myName("getImageId")
    fun getImageId(): Int? {
        return if (!isClient) {
            if (connected_product != -1)
                UINKDBInterface.activeDB.getClientProduct(connected_product).first?.id
            else {
               null
            }
        } else {
            id
        }

    }
    @myName("getConnectedProduct")
    fun getConnectedProduct(): List<Product> {
        return if (!isClient) {
            if (connected_product != -1)
                listOfNotNull(UINKDBInterface.activeDB.getClientProduct(connected_product).first)
            else {
                listOf()
            }
        } else {
            UINKDBInterface.activeDB.getAllSupplierProduct(true).first.filter { it.connected_product == id }
        }

    }

    @myName("getCostIncludeReturns")
    fun getCostIncludeReturns(curDate: String = DatesManipulator.dateNow()): Int {
        return productDated.get(curDate).cost_include_returns
    }

    @myName("getCostPrice")
    fun getCostPrice(curDate: String = DatesManipulator.dateNow()): Float {
        return productDated.get(curDate).cost_price
    }

    @myName("getNoTaxProduct")
    fun getNoTaxProduct(curDate: String = DatesManipulator.dateNow()): Int {
        return productDated.get(curDate).no_tax_product
    }

    @myName("getConnectedEntity")
    fun getConnectedEntity(): List<Entity> {
        return if (!isClient) {
            val suppliers = UINKDBInterface.activeDB.getAllSupplier(true).first
            suppliers.filter { it.getActiveProducts().any { p -> p.id == id } }

        } else {
            val clients = UINKDBInterface.activeDB.getAllClient(true).first
            clients.filter { it.getActiveProducts().any { p -> p.id == id } }
        }
    }

    @myName("getDefaultPrice")
    open fun getDefaultPrice(curDate: String = DatesManipulator.dateNow()): Float {
        return productDated.get(curDate).default_price
    }

    @myName("getBasePrice")
    open fun getBasePrice(curDate: String = DatesManipulator.dateNow()): Float {
        return productDated.get(curDate).base_price
    }

    @myName("getActive")
    open fun getActive(curDate: String = DatesManipulator.dateNow()): Boolean {
        return productDated.get(curDate).active == 1
    }

    @myName("getName")
    open fun getName(curDate: String = DatesManipulator.dateNow()): String {
        return productDated.get(if(curDate<= unclosed_date) DatesManipulator.dateNowNoHour()else  curDate).name
    }

    @myName("getPosition")
    open fun getPosition(curDate: String = DatesManipulator.dateNow()): Int {
        return productDated.get(curDate).position
    }

    @myName("getBarcode")
    open fun getBarcode(curDate: String = DatesManipulator.dateNow()): String {
        return productDated.get(curDate).barcode
    }

    @myName("getExternalId")
    open fun getExternalId(curDate: String = DatesManipulator.dateNow()): String {
        return productDated.get(curDate).external_id
    }

    @myName("getUnit")
    open fun getUnit(curDate: String = DatesManipulator.dateNow()): Int {
        return productDated.get(curDate).unit
    }

    @myName("getUnitAmmount")
    open fun getUnitAmmount(curDate: String = DatesManipulator.dateNow()): Float {
        return productDated.get(curDate).unit_amount
    }

    @myName("getCategory")
    open fun getCategory(curDate: String = DatesManipulator.dateNow()): String {
        return productDated.get(curDate).category
    }
    @myName("getCategory2")
    open fun getCategory2(curDate: String = DatesManipulator.dateNow()): String {
        return productDated.get(curDate).category2
    }
    @myName("getSplitCategory")
    open fun getSplitCategory(curDate: String = DatesManipulator.dateNow()): Int {
        return productDated.get(curDate).split_category
    }

    /**
     * Bundle expansion for Klinz / Priority (and Excel-style `bundle`).
     *
     * Catalog `notes3`:
     * - `bundle` — each member gets the full amount (10 → 10,10,10,10)
     * - `bundle_inverse` — amount is split evenly among members (40 → 10,10,10,10)
     *
     * `notes2` = child ids `id1_id2_...`. Prefer [lineNotes2] when it parses as ids.
     */
    fun resolveBundle(lineNotes2: String? = null): ProductBundle? {
        fun parse(raw: String?): List<Int> =
            raw?.split('_')
                ?.mapNotNull { it.trim().toIntOrNull() }
                ?.filter { it > 0 }
                .orEmpty()

        val mode = notes3?.trim()?.lowercase()
        val inverse = when (mode) {
            "bundle" -> false
            "bundle_inverse" -> true
            else -> return null
        }
        val members = parse(lineNotes2).ifEmpty { parse(notes2) }
        if (members.isEmpty()) return null
        return ProductBundle(memberIds = members, inverse = inverse)
    }

    /** @deprecated prefer [resolveBundle] */
    fun bundleMemberIds(lineNotes2: String? = null): List<Int> =
        resolveBundle(lineNotes2)?.memberIds.orEmpty()
}

/** Result of [Product.resolveBundle]. */
data class ProductBundle(
    val memberIds: List<Int>,
    /** true = divide source qty by member count; false = copy source qty to each member. */
    val inverse: Boolean,
) {
    fun amountPerMember(total: Float): Float {
        if (memberIds.isEmpty()) return 0f
        return if (inverse) total / memberIds.size else total
    }
}


